export default __webpack_public_path__ + "static/illustration-content-logo.url-c761fab3d3b67e9ce12acb5bba096816.svg";